// Shared client-side query cache: in-flight request dedup across widgets + short TTL,
// with ref-counted AbortController so cancelled widgets abort only unshared requests.
const entries = new Map();
const TTL = 45000;
const MAX = 300;

function prune() {
  if (entries.size <= MAX) return;
  const now = Date.now();
  for (const [k, e] of entries) {
    if (e.settledAt && now - e.settledAt > TTL) entries.delete(k);
    if (entries.size <= MAX) break;
  }
}

export function fetchShared(key, makeRequest) {
  const now = Date.now();
  let e = entries.get(key);
  if (e && (!e.settledAt || now - e.settledAt < TTL)) {
    e.refs += 1;
  } else {
    const controller = new AbortController();
    e = { refs: 1, controller, settledAt: null };
    e.promise = makeRequest(controller.signal)
      .then((d) => { e.settledAt = Date.now(); return d; })
      .catch((err) => { entries.delete(key); throw err; });
    entries.set(key, e);
    prune();
  }
  const entry = e;
  let released = false;
  return {
    promise: entry.promise,
    release: () => {
      if (released) return;
      released = true;
      entry.refs -= 1;
      if (entry.refs <= 0 && !entry.settledAt) {
        try { entry.controller.abort(); } catch { /* already aborted */ }
        entries.delete(key);
      }
    },
  };
}

export function clearQueryCache() { entries.clear(); }
